import { TranslateService } from '@ngx-translate/core';
import { ApiDataSource } from '../api.data-source';
import { of } from 'rxjs';
import { SystemUserService } from '../system-user/system-user.service';
import { debounceTime, filter, finalize, map } from 'rxjs/operators';
import { User } from '../api.model';
import { CustomerExperienceSLAService, SLABeginTimeType, SLAEndTimeType } from '@core/api';


export class CustomerExperienceSLADataSource extends ApiDataSource<any> {

    public isOpenedNewTab = false;

    public $status = of([
        { key: true, value: this.translate.instant('GENERAL.ACTIVE') },
        { key: false, value: this.translate.instant('GENERAL.PASSIVE') }
    ]);

    public $users = this.slaService.listCreatedUsers({ filter: {} }).pipe(
        map(response => response.data),
        map(users => users.map(item => {
            return {
                key: item.userId,
                value: item.displayName
            };
        }))
    );

    public $beginTimeTypes = of([
        { key: SLABeginTimeType.ASSIGNED_DATE, value: this.translate.instant('CX.ASSIGNED_DATE') },
        { key: SLABeginTimeType.CREATION_DATE, value: this.translate.instant('CX.CREATION_DATE') }
    ]);

    public $endTimeTypes = of([
        { key: SLAEndTimeType.FIRST_RESPONSE_DATE, value: this.translate.instant('CX.FIRST_RESPONSE_DATE') },
        { key: SLAEndTimeType.RESOLUTION_DATE, value: this.translate.instant('CX.RESOLUTION_DATE') }
    ].sort((a, b) => a.value.localeCompare(b.value)));

    private filterReq: any;

    constructor(
        private slaService: CustomerExperienceSLAService,
        private translate: TranslateService,
        protected initialFilter?: any,
    ) {
        super(initialFilter);
    }

    getFilter() {
        return this.filterReq;
    }

    load(): void {
        if (!this.isOpenedNewTab) {
            // Init filter with data source's default filter
            const filterValue: any = { ...this.initialFilter, ...this.filter };

            // If filter keyword exists, filter data
            if (this.keyword) {
                filterValue.searchText = this.keyword;
            }

            // Update loading state
            this.loadingSubject.next(true);

            // Create request parameters
            const request = this.getRequest();
            if (!request.orderType) {
                request.orderType = 'ASC';
                request.orderBy = 'orderBy';
            }

            if (this.paginator?.pageSize) {
                request.pageSize = this.paginator.pageSize;
            }

            // Add filters to request
            request.filter = filterValue;

            this.filterReq = { ...request };

            // Fetch data
            this.slaService
                .search(request)
                .pipe(
                    debounceTime(400),
                    finalize(() => this.loadingSubject.next(false))
                ).subscribe(response => {
                    // Update count and data subjects
                    this.dataSubject.next(response.data.results);
                    this.dataCountSubject.next(response.data.rowCount);

                    // Update data source's empty based row count
                    this.empty = response.data.rowCount === 0;
                });

        }

        return this.loadingSubject.next(false);
    }
}
